import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=37930b27&scoped=true&"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCarousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TestimonialCarousel.vue?vue&type=style&index=1&id=37930b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37930b27",
  null
  
)

export default component.exports